import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { AuthGuard } from '@auth0/auth0-angular';
import { appConfig } from './core/config/app-config';

const routes: Routes = [
  {
    path: '',
    redirectTo: appConfig.routes.main,
    pathMatch: 'full',
  },
  {
    path: 'init',
    loadChildren: () =>
      import('./public-pages/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'gb',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/pages.module').then((m) => m.PagesModule),
  },
  {
    path: '**',
    redirectTo: appConfig.routes.main,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
